import {
  SET_SKILLS,
} from './mutation-types';

export default {
  /**
  * Set media for a product
  * @param {object} state - the vuex state object
  * @param {Array} skills - IC skills array
  */
  [SET_SKILLS](state, skills) {
    state.skills = skills;
  },
};
